import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule-job-shift-dates',
  templateUrl: './schedule-job-shift-dates.component.html',
  styleUrls: ['./schedule-job-shift-dates.component.scss'],
})
export class ScheduleJobShiftDatesComponent implements OnInit {
  @Input() numberOfShifts: number;
  @Input() startDate: string;
  @Input() endDate: string;

  private _isHighlighted: boolean;
  @Input()
  get isHighlighted() {
    return this._isHighlighted;
  }
  set isHighlighted(highlighted: boolean) {
    this.handleHighlight(highlighted);
  }

  singleShiftDotSvgPath: string = 'assets/icons/schedule-dot.svg';
  multiShiftDotSvgPath: string = 'assets/icons/connector.svg';

  constructor() {}

  ngOnInit() {}

  handleHighlight(highlighted: boolean) {
    this._isHighlighted = highlighted;
    if (highlighted) {
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot-white.svg';
      this.multiShiftDotSvgPath = 'assets/icons/connector-white.svg';
    } else {
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot.svg';
      this.multiShiftDotSvgPath = 'assets/icons/connector.svg';
    }
  }
}
